/*
  Cobro del bordado "modo carrito" (02-oct-2026, v5 tras auditoria).
  Mientras la funcion de cobro (app myscrubs-bordado) no se pueda activar, el
  bordado se cobra como lo hacia Easify: con los productos ocultos de cargo como
  lineas aparte en el carro. Mismos productos y SKU => la boleta en Bsale sale igual.

  Cada prenda con bordado lleva la propiedad _bordado_id. Este script mira el carro
  y deja, por cada prenda, sus cargos (propiedad _bordado_de = ese id) con la cantidad
  correcta: los agrega si faltan, los ajusta si cambia la cantidad y los quita si la
  prenda se fue. El cliente no puede quedarse con el bordado sin pagarlo.

  v5 (auditoria 02-oct):
  - La cantidad deseada se cuenta POR VARIANTE. Linea 2 y Linea 3 usan el mismo producto
    y Shopify las junta en una sola linea de cantidad 2: antes eso se leia como descuadre
    y en cada pagina se reescribia el carro y se abria el carro lateral.
  - Prenda con datos de bordado pero sin _bordado_id (agregada por fuera de la ficha):
    se le cobran igual los cargos, atados a la clave de la linea. Las lineas viejas de
    Easify (_tpo_*) no se tocan: traen sus propios cargos.
  - Antes de ir a pagar se espera a que el carro este cuadrado. Si no se pudo cuadrar
    (por ejemplo, un cargo sin stock) se bloquea el pago y se avisa.
  - En /cart se recarga la pagina en vez de abrir el carro lateral encima.

  OJO: cuando se active la funcion de cobro hay que APAGAR este modo (sacar el
  script de layout/theme.liquid), si no se cobraria dos veces.
*/
(function () {
  var C = {
    linea1: 50535528071490,
    linea2: 50535537639746,
    linea3: 50535537639746, // linea 3 = producto "Linea 2" (decision 02-oct: misma tarifa que la linea 2)
    logo: 50535560905026,
    matriz: 52940703596866,
    bolsillo: 50551931535682
  };
  var CARGOS = {};
  Object.keys(C).forEach(function (k) { CARGOS[C[k]] = true; });
  var HANDLES = ['linea-1-1745254208931', 'linea-2-2010-1745254274406', 'logo-1745254553719', 'matriz-no-institucional', 'bosillo-utilizable-servicio-de-cosido'];
  var SECCIONES = 'cart-drawer,cart-icon-bubble';
  var ocupado = null, pendiente = false, cuadrado = true, ultimoError = '', pagando = false;

  // Las lineas de cargo no se pueden mover a mano: van atadas a la prenda.
  var css = HANDLES.map(function (h) {
    return 'tr:has(a[href*="/products/' + h + '"]) quantity-popover, tr:has(a[href*="/products/' + h + '"]) cart-remove-button, tr:has(a[href*="/products/' + h + '"]) .cart-item__quantity-wrapper';
  }).join(',') + '{visibility:hidden!important}' +
    '.bordado-aviso-carro{position:fixed;left:50%;bottom:1.6rem;transform:translateX(-50%);z-index:2147483000;max-width:min(92vw,48rem);background:#b3261e;color:#fff;padding:1.2rem 1.6rem;border-radius:8px;font-size:1.4rem;line-height:1.35;box-shadow:0 6px 24px rgba(0,0,0,.25)}';
  var st = document.createElement('style'); st.textContent = css; document.head.appendChild(st);

  function txt(v) { return typeof v === 'string' ? v.trim() : ''; }
  function cargosDe(p) {
    var out = [];
    if (txt(p['Linea 1'])) out.push(C.linea1);
    if (txt(p['Linea 2'])) out.push(C.linea2);
    if (txt(p['Linea 3'])) out.push(C.linea3);
    if (txt(p['Logo'])) out.push(C.logo);
    if (txt(p['Matriz'])) out.push(C.matriz);
    if (/^s[ií]/i.test(txt(p['Bolsillo'])) && txt(p['Ubicacion del bordado']) === 'Pecho Izquierdo') out.push(C.bolsillo);
    return out;
  }
  function esEasify(p) {
    return Object.keys(p).some(function (k) { return k.indexOf('_tpo_') === 0; });
  }

  function aviso(msg) {
    var el = document.querySelector('.bordado-aviso-carro');
    if (!msg) { if (el) el.remove(); return; }
    if (!el) { el = document.createElement('div'); el.className = 'bordado-aviso-carro'; el.setAttribute('role', 'alert'); document.body.appendChild(el); }
    el.textContent = msg;
  }

  function post(url, body) {
    return fetch(url, { method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify(body) })
      .then(function (r) {
        return r.json().catch(function () { return {}; }).then(function (j) { j = j || {}; if (!r.ok) j.status = j.status || r.status; return j; });
      });
  }

  function enCarro() { return /\/cart\/?$/.test(location.pathname); }
  function recargarCarro() {
    var k = 'bordado_recarga', ahora = Date.now(), prev = 0;
    try { prev = +sessionStorage.getItem(k) || 0; sessionStorage.setItem(k, String(ahora)); } catch (e) {}
    if (ahora - prev > 8000) location.reload();
  }
  function pintar(res) {
    if (enCarro()) { if (!pagando) recargarCarro(); return; }
    var d = document.querySelector('cart-drawer');
    if (res && res.sections && d && d.renderContents) {
      try { d.classList.remove('is-empty'); d.renderContents(res); } catch (e) {}
    }
  }

  // Devuelve una promesa que se resuelve cuando el carro quedo revisado (cuadrado o no).
  function sincronizar() {
    if (ocupado) { pendiente = true; return ocupado; }
    ocupado = fetch('/cart.js', { headers: { Accept: 'application/json' } }).then(function (r) { return r.json(); }).then(function (cart) {
      var prendas = {}, cargos = {};
      cart.items.forEach(function (it) {
        var p = it.properties || {};
        if (CARGOS[it.variant_id]) { if (p._bordado_de) (cargos[p._bordado_de] = cargos[p._bordado_de] || []).push(it); return; }
        if (esEasify(p)) return;
        var quiere = cargosDe(p);
        var id = p._bordado_id || (quiere.length ? 'k:' + it.key : '');
        if (!id) return;
        var q = prendas[id] || {};
        quiere.forEach(function (v) { q[v] = (q[v] || 0) + it.quantity; });
        prendas[id] = q;
      });
      var updates = {}, agregar = [];
      Object.keys(cargos).forEach(function (id) {
        var q = prendas[id] || {}, visto = {};
        cargos[id].forEach(function (it) {
          var objetivo = visto[it.variant_id] ? 0 : (q[it.variant_id] || 0);
          visto[it.variant_id] = true;
          if (it.quantity !== objetivo) updates[it.key] = objetivo;
        });
        if (prendas[id]) Object.keys(q).forEach(function (v) { if (!visto[v]) agregar.push({ id: +v, quantity: q[v], properties: { _bordado_de: id } }); });
      });
      Object.keys(prendas).forEach(function (id) {
        if (cargos[id]) return;
        Object.keys(prendas[id]).forEach(function (v) { agregar.push({ id: +v, quantity: prendas[id][v], properties: { _bordado_de: id } }); });
      });
      if (!Object.keys(updates).length && !agregar.length) { cuadrado = true; ultimoError = ''; aviso(''); return; }
      var paso = Promise.resolve(null), fallo = '';
      var revisar = function (res) { if (res && res.status >= 400) fallo = res.description || res.message || ('error ' + res.status); return res; };
      if (Object.keys(updates).length) paso = paso.then(function () { return post('/cart/update.js', { updates: updates, sections: SECCIONES, sections_url: location.pathname }); }).then(revisar);
      if (agregar.length) paso = paso.then(function () { return post('/cart/add.js', { items: agregar, sections: SECCIONES, sections_url: location.pathname }); }).then(revisar);
      return paso.then(function (res) {
        if (fallo) {
          cuadrado = false; ultimoError = fallo;
          console.warn('[bordado] no se pudo ajustar el carro', fallo);
          aviso('No pudimos agregar el cobro del bordado a tu carro (' + fallo + '). Quita el bordado de la prenda o escríbenos antes de pagar.');
          return;
        }
        cuadrado = true; ultimoError = ''; aviso('');
        if (res && res.items && !res.sections) return fetch('/?sections=' + SECCIONES).then(function (r) { return r.json(); }).then(function (s) { pintar({ sections: s }); });
        pintar(res);
      });
    }).catch(function (e) { cuadrado = false; ultimoError = 'sin conexión'; console.warn('[bordado]', e); }).then(function () {
      ocupado = null;
      if (pendiente) { pendiente = false; return sincronizar(); }
    });
    return ocupado;
  }

  // Antes de pagar: esperar a que el carro quede cuadrado (carrera al cambiar cantidades y pagar al tiro).
  var saltar = false;
  function bloquear() {
    aviso('No pudimos cuadrar el cobro del bordado' + (ultimoError ? ' (' + ultimoError + ')' : '') + '. Revisa tu carro o escríbenos antes de pagar.');
  }
  document.addEventListener('submit', function (e) {
    if (saltar) return;
    var f = e.target, b = e.submitter;
    var aPagar = (b && b.name === 'checkout') || /\/checkout/.test((f && f.getAttribute('action')) || '');
    if (!aPagar) return;
    e.preventDefault(); e.stopImmediatePropagation();
    var fid = f.id, conCheckout = !!(b && b.name === 'checkout'), valor = (b && b.value) || '1';
    pagando = true;
    sincronizar().then(function () {
      pagando = false;
      if (!cuadrado) { bloquear(); return; }
      // Al cuadrar, el carro lateral se vuelve a dibujar y el formulario original ya no esta en la pagina.
      var g = (fid && document.getElementById(fid)) || f;
      if (conCheckout && !g.querySelector('input[type=hidden][name=checkout]')) {
        var h = document.createElement('input'); h.type = 'hidden'; h.name = 'checkout'; h.value = valor; g.appendChild(h);
      }
      // Las cantidades ya estan guardadas por AJAX. Los updates[] del formulario pueden venir
      // desfasados (en /cart no se redibuja) y Shopify los aplicaria al pagar: no se mandan.
      Array.prototype.forEach.call(g.elements || [], function (el) { if (el.name === 'updates[]') el.removeAttribute('name'); });
      saltar = true;
      setTimeout(function () { saltar = false; }, 4000);
      if (g.requestSubmit) g.requestSubmit(); else g.submit();
    });
  }, true);
  document.addEventListener('click', function (e) {
    if (saltar || !e.target.closest) return;
    var a = e.target.closest('a[href*="/checkout"]');
    if (!a) return;
    e.preventDefault(); e.stopImmediatePropagation();
    pagando = true;
    sincronizar().then(function () { pagando = false; if (cuadrado) location.href = a.href; else bloquear(); });
  }, true);

  function suscribir() {
    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
      subscribe(PUB_SUB_EVENTS.cartUpdate, function () { setTimeout(sincronizar, 60); });
    }
    sincronizar();
  }
  window.BordadoCarrito = { sincronizar: sincronizar, estado: function () { return { cuadrado: cuadrado, error: ultimoError }; } };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', suscribir); else suscribir();
})();
